
    import { main } from '/src/index.tsx'
    main()
  